/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

import { AlertBanner as Banner } from 'components/alert-banner'
import { TAlertBannerProps } from '.'
import type { Products } from '@web/product-meta'

export const AlertBanner = ({ data }: { data: TAlertBannerProps }) => {
	const notExpired =
		data?.expirationDate && Date.now() < Date.parse(data?.expirationDate)

	if (notExpired) {
		return <Banner {...data} product={data.theme.toLowerCase() as Products} />
	} else {
		return null
	}
}
